var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "big" },
    [
      _c(
        "el-card",
        [
          _c(
            "span",
            [
              _vm._v("是否开启权重 "),
              _c("el-switch", {
                staticStyle: { "margin-left": "10px" },
                attrs: {
                  "active-color": "#13ce66",
                  "inactive-color": "#ff4949",
                  "active-value": 1,
                  "inactive-value": 0,
                },
                on: { change: _vm.switchMode },
                model: {
                  value: _vm.type,
                  callback: function ($$v) {
                    _vm.type = $$v
                  },
                  expression: "type",
                },
              }),
            ],
            1
          ),
          _vm.showAuto === 0
            ? _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "10px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.editWeightfn },
                },
                [_vm._v(" 表格修改完成 ")]
              )
            : _vm._e(),
          _vm.showAuto !== 3
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.switchData(3)
                    },
                  },
                },
                [_vm._v(" 查看实时通道数据 ")]
              )
            : _vm._e(),
          _vm.showAuto !== 0
            ? _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "10px" },
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.switchData(0)
                    },
                  },
                },
                [_vm._v(" 查看代付通道数据 ")]
              )
            : _vm._e(),
          _vm.showAuto !== 2
            ? _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "10px" },
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.switchData(2)
                    },
                  },
                },
                [_vm._v(" 报错而下掉的代付通道 ")]
              )
            : _vm._e(),
          _vm.showAuto === 0
            ? _c(
                "el-dropdown",
                { staticClass: "dropdown", on: { command: _vm.addTable } },
                [
                  _c("el-button", { attrs: { type: "primary" } }, [
                    _vm._v(" 添加渠道"),
                    _c("i", {
                      staticClass: "el-icon-arrow-down el-icon--right",
                    }),
                  ]),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    _vm._l(_vm.methodList, function (item, index) {
                      return _c(
                        "el-dropdown-item",
                        { key: index, attrs: { command: item } },
                        [_vm._v(_vm._s(item) + " ")]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { sm: 7, xs: 0 } },
        [
          _c(
            "el-card",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.availableChannlVisble = true
                    },
                  },
                },
                [_vm._v("添加可用通道")]
              ),
              _c("p", [_vm._v("当前通道配置")]),
              _c("p", [_vm._v("可用通道")]),
              _c(
                "draggable",
                {
                  attrs: { group: _vm.grouptableA },
                  on: { end: _vm.grouptableEnd },
                  model: {
                    value: _vm.channelsList,
                    callback: function ($$v) {
                      _vm.channelsList = $$v
                    },
                    expression: "channelsList",
                  },
                },
                _vm._l(_vm.channelsList, function (item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "channl" },
                    [
                      _c(
                        "el-tag",
                        {
                          staticStyle: { height: "150px" },
                          attrs: { closable: "" },
                          on: {
                            close: function ($event) {
                              return _vm.removeAvailableChannle(index)
                            },
                          },
                        },
                        [
                          _c("div", [
                            _vm._v(" 通道： " + _vm._s(item.channelStr)),
                          ]),
                          _c("div", [
                            _vm._v(" 通道名称： " + _vm._s(item.sign)),
                          ]),
                          _c("div", [_vm._v("payKey: " + _vm._s(item.payKey))]),
                          _c("div", [
                            _vm._v("代付余额： " + _vm._s(item.maxCash)),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                }),
                0
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { sm: 17, xs: 24 } },
        _vm._l(_vm.tableData, function (item, index) {
          return _vm.showAuto !== 2
            ? _c(
                "div",
                { key: index },
                [
                  _c("el-card", [
                    _c("h3", { staticClass: "title" }, [
                      _vm._v(_vm._s(item.method)),
                    ]),
                  ]),
                  _vm.showAuto === 0
                    ? _c(
                        "draggable",
                        {
                          attrs: {
                            options: { handle: ".dd" },
                            group: _vm.grouptable,
                          },
                          model: {
                            value: item.list,
                            callback: function ($$v) {
                              _vm.$set(item, "list", $$v)
                            },
                            expression: "item.list",
                          },
                        },
                        [
                          _c(
                            "el-table",
                            {
                              attrs: {
                                title: item.method,
                                "show-summary": "",
                                data: item.list,
                              },
                            },
                            [
                              _vm.showAuto === 0
                                ? _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      label: "序号",
                                      prop: "number",
                                    },
                                  })
                                : _vm._e(),
                              _c("el-table-column", {
                                attrs: {
                                  align: "center",
                                  label: "通道名称",
                                  prop: "channelStr",
                                },
                              }),
                              _c("el-table-column", {
                                key: _vm.tableKey,
                                attrs: {
                                  align: "center",
                                  label: "权重",
                                  prop: "weight",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("el-input", {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  scope.$index +
                                                    item.method +
                                                    "weight" ===
                                                  _vm.displayindex,
                                                expression:
                                                  "scope.$index+item.method+'weight' === displayindex",
                                              },
                                            ],
                                            on: {
                                              keydown: function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                return _vm.editWeightOnefn(
                                                  index,
                                                  scope.$index,
                                                  _vm.weightNumber,
                                                  1
                                                )
                                              },
                                              blur: function ($event) {
                                                return _vm.editWeightOnefn(
                                                  index,
                                                  scope.$index,
                                                  _vm.weightNumber,
                                                  1
                                                )
                                              },
                                            },
                                            model: {
                                              value: _vm.weightNumber,
                                              callback: function ($$v) {
                                                _vm.weightNumber = _vm._n($$v)
                                              },
                                              expression: "weightNumber",
                                            },
                                          }),
                                          _c(
                                            "span",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    scope.$index +
                                                      item.method +
                                                      "weight" !==
                                                    _vm.displayindex,
                                                  expression:
                                                    "scope.$index+item.method+'weight' !== displayindex",
                                                },
                                              ],
                                              staticStyle: {
                                                cursor: "pointer",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.displayindex =
                                                    scope.$index +
                                                    item.method +
                                                    "weight"
                                                  _vm.weightNumber =
                                                    scope.row.weight
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(scope.row.weight) +
                                                  "% "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _c("el-table-column", {
                                key: _vm.tableKey,
                                attrs: {
                                  align: "center",
                                  label: "区间内权重",
                                  prop: "payOutLimitWeight",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("el-input", {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  scope.$index +
                                                    item.method +
                                                    "payOutLimitWeight" ===
                                                  _vm.displayindex,
                                                expression:
                                                  "scope.$index+item.method+'payOutLimitWeight' === displayindex",
                                              },
                                            ],
                                            on: {
                                              keydown: function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                return _vm.editWeightOnefn(
                                                  index,
                                                  scope.$index,
                                                  _vm.weightNumber,
                                                  2
                                                )
                                              },
                                              blur: function ($event) {
                                                return _vm.editWeightOnefn(
                                                  index,
                                                  scope.$index,
                                                  _vm.weightNumber,
                                                  2
                                                )
                                              },
                                            },
                                            model: {
                                              value: _vm.weightNumber,
                                              callback: function ($$v) {
                                                _vm.weightNumber = _vm._n($$v)
                                              },
                                              expression: "weightNumber",
                                            },
                                          }),
                                          _c(
                                            "span",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    scope.$index +
                                                      item.method +
                                                      "payOutLimitWeight" !==
                                                    _vm.displayindex,
                                                  expression:
                                                    "scope.$index+item.method+'payOutLimitWeight' !== displayindex",
                                                },
                                              ],
                                              staticStyle: {
                                                cursor: "pointer",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.displayindex =
                                                    scope.$index +
                                                    item.method +
                                                    "payOutLimitWeight"
                                                  _vm.weightNumber =
                                                    scope.row.payOutLimitWeight
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    scope.row.payOutLimitWeight
                                                  ) +
                                                  "% "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _c("el-table-column", {
                                key: _vm.tableKey,
                                attrs: {
                                  align: "center",
                                  label: "区间最小值",
                                  prop: "payOutLimitStart",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("el-input", {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  scope.$index +
                                                    item.method +
                                                    "payOutLimitStart" ===
                                                  _vm.displayindex,
                                                expression:
                                                  "scope.$index+item.method+'payOutLimitStart' === displayindex",
                                              },
                                            ],
                                            on: {
                                              keydown: function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                return _vm.editWeightOnefn(
                                                  index,
                                                  scope.$index,
                                                  _vm.weightNumber,
                                                  3
                                                )
                                              },
                                              blur: function ($event) {
                                                return _vm.editWeightOnefn(
                                                  index,
                                                  scope.$index,
                                                  _vm.weightNumber,
                                                  3
                                                )
                                              },
                                            },
                                            model: {
                                              value: _vm.weightNumber,
                                              callback: function ($$v) {
                                                _vm.weightNumber = _vm._n($$v)
                                              },
                                              expression: "weightNumber",
                                            },
                                          }),
                                          _c(
                                            "span",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    scope.$index +
                                                      item.method +
                                                      "payOutLimitStart" !==
                                                    _vm.displayindex,
                                                  expression:
                                                    "scope.$index+item.method+'payOutLimitStart' !== displayindex",
                                                },
                                              ],
                                              staticStyle: {
                                                cursor: "pointer",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.displayindex =
                                                    scope.$index +
                                                    item.method +
                                                    "payOutLimitStart"
                                                  _vm.weightNumber =
                                                    scope.row.payOutLimitStart
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    scope.row.payOutLimitStart
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _c("el-table-column", {
                                key: _vm.tableKey,
                                attrs: {
                                  align: "center",
                                  label: "区间最大值",
                                  prop: "payOutLimitEnd",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("el-input", {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  scope.$index +
                                                    item.method +
                                                    "payOutLimitEnd" ===
                                                  _vm.displayindex,
                                                expression:
                                                  "scope.$index+item.method+'payOutLimitEnd' === displayindex",
                                              },
                                            ],
                                            on: {
                                              keydown: function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                return _vm.editWeightOnefn(
                                                  index,
                                                  scope.$index,
                                                  _vm.weightNumber,
                                                  4
                                                )
                                              },
                                              blur: function ($event) {
                                                return _vm.editWeightOnefn(
                                                  index,
                                                  scope.$index,
                                                  _vm.weightNumber,
                                                  4
                                                )
                                              },
                                            },
                                            model: {
                                              value: _vm.weightNumber,
                                              callback: function ($$v) {
                                                _vm.weightNumber = _vm._n($$v)
                                              },
                                              expression: "weightNumber",
                                            },
                                          }),
                                          _c(
                                            "span",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    scope.$index +
                                                      item.method +
                                                      "payOutLimitEnd" !==
                                                    _vm.displayindex,
                                                  expression:
                                                    "scope.$index+item.method+'payOutLimitEnd' !== displayindex",
                                                },
                                              ],
                                              staticStyle: {
                                                cursor: "pointer",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.displayindex =
                                                    scope.$index +
                                                    item.method +
                                                    "payOutLimitEnd"
                                                  _vm.weightNumber =
                                                    scope.row.payOutLimitEnd
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    scope.row.payOutLimitEnd
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  align: "center",
                                  label: "payKey",
                                  prop: "payKey",
                                },
                              }),
                              _vm.showAuto === 0
                                ? _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      label: "状态",
                                      prop: "payOutChannelStatus",
                                    },
                                  })
                                : _vm._e(),
                              _vm.showAuto === 0
                                ? _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      label: "拉起成功率",
                                      prop: "pullUpRate",
                                    },
                                  })
                                : _vm._e(),
                              _vm.showAuto === 0
                                ? _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      label: "回调成功率",
                                      prop: "notifyRate",
                                    },
                                  })
                                : _vm._e(),
                              _c("el-table-column", {
                                attrs: { label: "操作" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("el-button", {
                                            attrs: {
                                              type: "danger",
                                              icon: "el-icon-delete",
                                              circle: "",
                                              size: "mini",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.deleteUnAutoChannl(
                                                  item.method,
                                                  scope.$index
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showAuto === 3
                    ? _c(
                        "el-table",
                        {
                          key: _vm.tableKey,
                          attrs: { title: item.method, data: item.list },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "通道名称",
                              prop: "ChannelStr",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "权重",
                              prop: "Weight",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        " " + _vm._s(scope.row.Weight) + "% "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "PayOutKey",
                              prop: "PayOutKey",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "代收余额",
                              prop: "MaxPayInCash",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _c(
                "div",
                [
                  _c("el-card", [
                    _c("h3", { staticClass: "title" }, [
                      _vm._v("因为报错权重下降到0的权重"),
                    ]),
                  ]),
                  _c(
                    "el-table",
                    { attrs: { data: _vm.zeroListTableData } },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "channelStr", label: "通道名称" },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "payKey", label: "PayKey" },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "initWeight", label: "初始的权重" },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "nowWeight", label: "现在的权重" },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "操作" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary", size: "mini" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.restoreWeight(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v(" 恢复初始权重 ")]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c("el-card", [
                    _c("h3", { staticClass: "title" }, [
                      _vm._v("因为报错权重下降到1的权重"),
                    ]),
                  ]),
                  _c(
                    "el-table",
                    { attrs: { data: _vm.oneListTableData } },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "channelStr", label: "通道名称" },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "payKey", label: "PayKey" },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "initWeight", label: "初始的权重" },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "nowWeight", label: "现在的权重" },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "操作" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary", size: "mini" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.restoreWeight(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v(" 恢复初始权重 ")]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
        }),
        0
      ),
      _c(
        "el-dialog",
        {
          attrs: { title: "添加可用通道", visible: _vm.availableChannlVisble },
          on: {
            "update:visible": function ($event) {
              _vm.availableChannlVisble = $event
            },
            close: _vm.clearAvailableChannl,
          },
        },
        [
          _c(
            "el-form",
            { attrs: { inline: true } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "选择通道" } },
                [
                  _c("el-cascader", {
                    attrs: {
                      options: _vm.selectAddChannl,
                      props: {
                        value: "select",
                        label: "ID",
                        lazy: true,
                        lazyLoad: _vm.dynamicallyLoadingData,
                      },
                    },
                    model: {
                      value: _vm.addOneChannel,
                      callback: function ($$v) {
                        _vm.addOneChannel = $$v
                      },
                      expression: "addOneChannel",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "输入最大代付金额" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.maxCash,
                      callback: function ($$v) {
                        _vm.maxCash = _vm._n($$v)
                      },
                      expression: "maxCash",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.availableChannlVisble = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.addAvailableChannl },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }